import { render, staticRenderFns } from "./addorupdateExtra.vue?vue&type=template&id=b68fe9fa"
import script from "./addorupdateExtra.vue?vue&type=script&lang=js"
export * from "./addorupdateExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports